import React from 'react';
import { Alert, Box, LinearProgress, Stack, Typography } from '@mui/material';
import { ScienceOutlined } from '@mui/icons-material';
import { useTenant } from '../contexts/TenantContext';
import { usePermissions } from '../contexts/PermissionContext';
import AgentResearch from '../components/AgentResearch';

const Research: React.FC = () => {
  const { selectedTenant } = useTenant();
  const { hasPermission, loading } = usePermissions();
  if (loading) return <LinearProgress aria-label="Loading permissions" />;
  if (!selectedTenant) return <Alert severity="info">Select a tenant to research simulation scenarios.</Alert>;
  if (!hasPermission('research_scenarios', 'tenant', selectedTenant.tenant_id)) return <Alert severity="warning">Scenario research requires operator access to this tenant.</Alert>;

  return <Stack spacing={3}>
    <Box>
      <Typography variant="h4" component="h1"><ScienceOutlined sx={{ mr: 1, verticalAlign: 'middle' }} />Scenario Research</Typography>
      <Typography color="text.secondary">Research targets with AI and review simulation candidates.</Typography>
    </Box>
    {/* Drop drafts and pending responses when the selected tenant changes. */}
    <AgentResearch key={selectedTenant.tenant_id} tenantId={selectedTenant.tenant_id} />
  </Stack>;
};

export default Research;
